// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class HighLowData {
    constructor(type) {
        this.EventType = type;
    }
}
export const IsHigh = (type) => {
    return type === HighLowEventType.TouchHigh || type === HighLowEventType.BreakingHigh;
};
export var HighLowEventType;
(function (HighLowEventType) {
    HighLowEventType[HighLowEventType["TouchHigh"] = 1] = "TouchHigh";
    HighLowEventType[HighLowEventType["TouchLow"] = 2] = "TouchLow";
    HighLowEventType[HighLowEventType["BreakingHigh"] = 3] = "BreakingHigh";
    HighLowEventType[HighLowEventType["BreakingLow"] = 4] = "BreakingLow";
})(HighLowEventType || (HighLowEventType = {}));
